<!-- @format -->

<div
  [id]="isMobile() ? 'filter-mobile-' + filterOption().value : 'filter-' + filterOption().value"
  class="single-filter hmf-body-m hmf-align-items-center"
  [class.is-disabled]="disabled()">
  @if (filterOptionType() === FilterOptionType.Radio) {
    <hmf-radio
      class="filter-radio hmf-flex-shrink-none"
      [id]="`${isMobile() ? 'mobile-' : ''}${attributeIdentifier()}-${filterOption().value}`"
      [disabled]="disabled()"
      [checked]="checked()"
      [aria-label]="ariaLabel()"
      (eventChange)="handleClick()">
      @if (labelAsHmfInputContent()) {
        <ng-container *ngTemplateOutlet="label"></ng-container>
      }
    </hmf-radio>
  } @else if (filterOptionType() === FilterOptionType.Checkbox) {
    <hmf-checkbox
      class="filter-name"
      [id]="`${isMobile() ? 'mobile-' : ''}${attributeIdentifier()}-${filterOption().value}`"
      [disabled]="disabled()"
      [checked]="checked()"
      [ariaLabel]="ariaLabel()"
      (eventChange)="handleClick()">
      @if (labelAsHmfInputContent()) {
        <ng-container *ngTemplateOutlet="label"></ng-container>
      }
    </hmf-checkbox>
  }
  <div
    class="filter-value-count-container hmf-display-flex hmf-justify-content-between hmf-align-items-center"
    [class.hmf-ml-xxxs]="filterOptionType() === FilterOptionType.Selector"
    [attr.role]="filterOptionType() === FilterOptionType.Selector ? 'link' : null"
    [attr.tabindex]="filterOptionType() === FilterOptionType.Selector ? 0 : null"
    [attr.aria-label]="filterOptionType() === FilterOptionType.Selector ? ariaLabel() : null"
    [class.is-disabled]="disabled()"
    (keydown.space)="handleSpace($event)"
    (click)="handleClick()">
    @if (!labelAsHmfInputContent()) {
      <ng-container *ngTemplateOutlet="label"></ng-container>
    }
    @if (!(attributeName() === GTGT_FILTER_NAME && filterOption().value === 'N')) {
      <div
        class="filter-count"
        [attr.id]="`${isMobile() ? 'mobile-count-' : 'count-'}${attributeIdentifier()}-${filterOption().value}`"
        [class.is-disabled]="disabled()">
        {{ filterOption().count | usWholeNumber }}
      </div>
    }
  </div>
</div>

<ng-template #label>
  @if (projectedLabelTemplate()) {
    <ng-container *ngTemplateOutlet="projectedLabelTemplate()"></ng-container>
  } @else if (attributeName() === 'Color') {
    <div
      class="hmf-display-flex hmf-align-items-center"
      [class.is-disabled]="disabled()">
      <hmf-selector
        radius="50%"
        class="hmf-ml-xxxs hmf-display-flex"
        [height]="'16px'"
        [width]="'16px'"
        inert [color]="filterOption().value" selector="circular" circleVariant="xxsmall"
        [imageSrc]="filterOption().value === 'Multi' ? MULTICOLOR_IMAGE : undefined"
        [selected]="selectedOptions().includes(filterOption().value)"
        [disabled]="disabled()">
      </hmf-selector>
      {{ filterOption().value }}
    </div>
  } @else {
    <div
      [class.is-disabled]="disabled()">
      {{ displayValue() }}
    </div>
  }
</ng-template>
